import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import {
  ReceiptReturnInvoice,
  ReceiptReturnInsertData,
  ReceiptReturnVm,
  ApiResponse,
} from '@/api/types'

/**
 * Receipt Return management service
 * Handles all receipt return-related API operations
 */
export class ReceiptReturnService {
  /**
   * Get invoices by customer ID
   */
  async getInvoicesByCustomerId(customerId: number): Promise<ReceiptReturnInvoice[]> {
    const url = endpoints.receiptReturn.getInvoicesByCustomerId(customerId)
    const response = await apiClient.get<ApiResponse<ReceiptReturnInvoice[]> | ReceiptReturnInvoice[] | any>(url)
    
    if (Array.isArray(response.data)) {
      return response.data
    }
    if ('data' in response.data && Array.isArray(response.data.data)) {
      return response.data.data
    }
    return []
  }

  /**
   * Get insert data for receipt return
   */
  async getInsertData(branchId: number, invoiceId: number): Promise<ReceiptReturnInsertData> {
    const url = endpoints.receiptReturn.getInsertData(branchId, invoiceId)
    const response = await apiClient.get<ApiResponse<ReceiptReturnInsertData> | ReceiptReturnInsertData | any>(url)
    
    if (response.data && typeof response.data === 'object') {
      if ('data' in response.data) {
        return response.data.data as ReceiptReturnInsertData
      }
      return response.data as ReceiptReturnInsertData
    }
    
    throw new Error('Invalid response format from GetInsertData')
  }

  /**
   * Save receipt return (POST)
   */
  async saveReceiptReturn(data: ReceiptReturnVm): Promise<any> {
    const url = endpoints.receiptReturn.save
    console.log('🔵 [ReceiptReturnService] POST Request URL:', url)
    console.log('🔵 [ReceiptReturnService] POST Request Data:', JSON.stringify(data, null, 2))
    console.log('🔵 [ReceiptReturnService] POST Request Data Object:', data)
    
    try {
      const response = await apiClient.post<ApiResponse<any> | any>(url, data)
      console.log('✅ [ReceiptReturnService] POST Response:', response)
      return response.data
    } catch (error: any) {
      console.error('❌ [ReceiptReturnService] POST Error:', error)
      console.error('❌ [ReceiptReturnService] POST Error Response:', error.response)
      console.error('❌ [ReceiptReturnService] POST Error Data:', error.response?.data)
      throw error
    }
  }

  /**
   * Update receipt return (PUT)
   */
  async updateReceiptReturn(data: ReceiptReturnVm): Promise<any> {
    const url = endpoints.receiptReturn.update
    const response = await apiClient.put<ApiResponse<any> | any>(url, data)
    return response.data
  }
}

export const receiptReturnService = new ReceiptReturnService()
